import { useCallback, useState } from 'react';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { REMOVE_ASSETS } from '../../apollo/assets.ts';
import { AssetStatus } from '../../apollo/__generated__/graphql.ts';

export const useRemoveAsset = (afterRemove?: () => void) => {
  const [isModalOpen, setModal] = useState(false);
  const [remove] = useMutation(REMOVE_ASSETS);
  const onRemoveAsset = (id: number) => {
    const promise = remove({
      variables: {
        input: {
          ids: [id],
        },
      },
    });

    toast.promise(promise, {
      pending: `Deleting Asset...`,
      success: `Asset deleted`,
    });

    promise.then(() => {
      if (afterRemove) afterRemove();
    });
  };

  const toggleModal = () => setModal((prevState) => !prevState);

  return {
    onRemoveAsset,
    toggleModal,
    isModalOpen,
  };
};

export const useAssetsSearch = () => {
  const [filter, setFilter] = useState<{
    id?: string;
    name?: string;
    description?: string;
    status?: AssetStatus;
  }>({
    id: undefined,
    name: undefined,
    description: undefined,
    status: undefined,
  });
  const onChangeFilter = useCallback((value?: string, type?: string) => {
    setFilter((prev) => {
      const next = {
        id: type === 'id' ? value : undefined,
        name: type === 'name' ? value : undefined,
        description: type === 'description' ? value : undefined,
        status: type === 'status' ? (value as AssetStatus | undefined) : undefined,
      };

      if (
        prev.id === next.id &&
        prev.name === next.name &&
        prev.description === next.description &&
        prev.status === next.status
      ) {
        return prev;
      }

      return next;
    });
  }, []);

  return { filter, onChangeFilter };
};
